import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kx-pin-authenticated',
    templateUrl: './pin-authenticated.component.html',
    styleUrls: ['./pin-authenticated.component.scss'],
    standalone: false
})
export class PinAuthenticatedComponent implements OnInit {
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };

  constructor() { }

  ngOnInit(): void {
  }

  onOtpChange(event:any){

  }

  handleEvent(event:any):void {

  }

  onSelect(event:any){

  }

  getValue(){
    return true
  }

  generatePin(event){
    
  }

}
